import SarcopeniaMeasureStore from "./SarcopeniaMeasureStore";
import PanelControlStore from "./panelControlStore";
import AuthStore from "./authStore";
const Store = {
  SarcopeniaMeasureStore,
  PanelControlStore,
  AuthStore
};

export default Store;
